export const MESSAGE_STATUS_CONSTANT = Object.freeze({
    SEND: 'send',
    ACK: 'ack',
    DELIVERED: 'delivered',
    ACKDElIVERED: 'ackdelivered',
    SEEN: 'seen',
    ACKSEEN: 'ackseen',
    USER_TYPING: 'userTyping',
    KEEP_ALIVE: 'keepalive'
});